export const GEAR_LOCALE = {
  enGB: 'en-GB',
  plPL: 'pl-PL',
  ro: 'ro-RO',
  et: 'et-EE',
  nl: 'nl-NL',
  fr: 'fr-FR',
  hr: 'hr-HR'
} as const;

export type GearLocale = (typeof GEAR_LOCALE)[keyof typeof GEAR_LOCALE];
